
const { ccclass, menu, property, executeInEditMode, inspector, requireComponent } = cc._decorator;

const Mode = cc.ProgressBar.Mode
const misc = cc.misc

@ccclass
@menu('custom/CustomProgressBar')
@executeInEditMode
export default class CustomProgressBar extends cc.ProgressBar {

    @property(cc.Boolean)
    useMove: boolean = false

    _updateBarStatus() {
        if(!this.useMove){
            super['_updateBarStatus']()
        }else{
            if (this.barSprite) {
                var entity = this.barSprite.node;
    
                if (!entity) return;
    
                var entitySize = entity.getContentSize();
    
                var anchorPoint = cc.v2(1, 0.5);
                var progress = misc.clamp01(this.progress);
                var actualLenth = this.totalLength * progress;
                switch (this.mode) {
                    case Mode.HORIZONTAL:
                        if (this.reverse) {
                            anchorPoint = cc.v2(0, 0.5);
                        }
                        entity.setAnchorPoint(anchorPoint)
                        entity.x = this.reverse? (this.totalLength * 0.5 - actualLenth): (actualLenth - this.totalLength * 0.5)
                        break;
                    case Mode.VERTICAL:
                        if (this.reverse) {
                            anchorPoint = cc.v2(0.5, 0);
                        } else {
                            anchorPoint = cc.v2(0.5, 1);
                        }
                        entity.setAnchorPoint(anchorPoint)
                        entity.y = this.reverse? (this.totalLength * 0.5 - actualLenth): (actualLenth - this.totalLength * 0.5)
                        break;
                }
    
            }
        }
        
    }

}